import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})

const store = new Vuex.Store({
    state() {
        return {
            storedData: [],
            user: {},
        }
    },
    mutations: {
        setStoredData(st, val) {
            if (st.storedData == undefined)
                st.storedData = []
            st.storedData.push(val)
        },
        clearStoredDataById(st, id) {
            let findedIndx = st.storedData.findIndex((val) => val.data.CLD_IDEnreg == id)
            
            if (st.storedData && st.storedData.length > 0 && findedIndx !== -1) {
                st.storedData.splice(findedIndx, 1);
            }
        },
        clearStoredData(st) {
            st.storedData = []
        },
    },
    plugins: [vuexLocal.plugin]
});

export default store